export default "__VITE_ASSET__7b18ef85__"